import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../styles/auth/RegistrationSuccess.css';

const RegistrationSuccess = () => {
    const [countdown, setCountdown] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prevCount) => {
                if (prevCount === 1) {
                    clearInterval(timer);
                    navigate('/login');
                }
                return prevCount - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [navigate]);

    return (
        <div className="registration-success-container">
            <div className="registration-success-card">
                <h2 className="registration-success-title">Registration Successful</h2>
                <div className="registration-success-message">
                    <p>Thank you for registering with TTLSend!</p>
                    <p>An administrator will review and approve your request.</p>
                    <p>You will receive an email with a clickable link to complete the registration process once approved.</p>
                </div>
                <div className="registration-success-footer">
                    <p className="registration-success-countdown">Redirecting to login page in {countdown} seconds</p>
                    <Link to="/login" className="registration-success-link">Return to Login</Link>
                </div>
            </div>
        </div>
    );
};

export default RegistrationSuccess;